<template>
  <el-dialog
    :visible="true"
    :style="{ paddingTop: '10vh' }"
    :before-close="handleClose"
    title="设置"
    width="45vw"
    class="bc500-setting"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :model="data"
      :rules="rules"
      label-width="130px"
      :inline="true"
    >
      <div class="column">
        <el-form-item label="采样时间" prop="sampleTime">
          <el-input v-model="data.sampleTime"></el-input>
          <span class="unit">秒</span>
        </el-form-item>
        <el-form-item label="等待采样时间" prop="sampleWaitTime">
          <el-input v-model="data.sampleWaitTime"></el-input>
          <span class="unit">秒</span>
        </el-form-item>
        <el-form-item label="开门中断时间" prop="doorBreakTime">
          <el-input v-model="data.doorBreakTime"></el-input>
          <span class="unit">秒</span>
        </el-form-item>
      </div>
      <div class="column">
        <el-form-item label="流量参数" prop="sampleFlow">
          <el-input v-model="data.sampleFlow"></el-input>
          <span class="unit">L/min</span>
        </el-form-item>
      </div>
    </el-form>
    <div class="handler">
      <el-button class="confirm" type="primary" :loading="confirmLoading" @click="save">
        确定
      </el-button>
      <el-button class="cancel" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDeviceStatus, paramSetting } from '@/api/deviceSetting';
import { translateTo } from '@/utils/locale';

var makeValidate = ({ min, max, msg, i18n }) => {
  const validator = (_, value, callback) => {
    if (value >= min && value <= max) {
      callback();
    } else {
      callback(new Error(translateTo(msg, i18n, { min, max })));
    }
  };
  return { validator };
};

const common = {
  message: '必须为数值',
  validator(rule, value, callback) {
    if (/^\d+$/.test(value)) {
      callback();
    } else {
      callback(new Error(translateTo(rule.message, 'layout')));
    }
  },
  trigger: 'blur'
};

export default {
  props: {
    sn: {
      type: String,
      default: ''
    },
    deviceType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      confirmLoading: false,
      oldData: {},
      data: {
        sampleTime: '',
        sampleWaitTime: '',
        doorBreakTime: '',
        sampleFlow: ''
      },
      rules: {
        sampleTime: [
          common,
          makeValidate({
            min: 0,
            max: 65536,
            msg: '采样时间取值范围模板',
            i18n: 'layout'
          })
        ],
        sampleWaitTime: [
          common,
          makeValidate({
            min: 0,
            max: 65536,
            msg: '等待采样时间有效值范围模板',
            i18n: 'layout'
          })
        ],
        doorBreakTime: [
          common,
          makeValidate({
            min: 0,
            max: 65536,
            msg: '开门中断时间有效值范围模板',
            i18n: 'layout'
          })
        ],
        sampleFlow: [
          common,
          makeValidate({
            min: 100,
            max: 240,
            msg: '流量有效值范围模板',
            i18n: 'layout'
          })
        ]
      }
    };
  },
  methods: {
    handleClose(done) {
      this.$destroy();
      document.querySelector('.bc500-setting').remove();
      typeof done === 'function' && done();
    },
    getParams() {
      const keys = Object.keys(this.oldData);
      return keys.reduce((map, key) => {
        if (this.oldData[key] !== this.data[key]) map[key] = this.data[key];
        return map;
      }, {});
    },
    clearLoading() {
      const timer = setTimeout(() => {
        this.loading = false;
        this.confirmLoading = false;
        clearTimeout(timer);
      }, 500);
    },
    getDeviceStatus() {
      this.loading = true;
      this.confirmLoading = true;
      getDeviceStatus({ sn: this.sn, deviceType: this.deviceType, busiType: 1 })
        .then(res => {
          const { data } = res || {};
          if (!data) return;
          Object.assign(this.data, {
            deviceTime: data.deviceTime,
            doorBreakTime: data.doorBreakTime,
            sampleFlow: data.sampleFlow,
            sampleTime: data.sampleTime,
            sampleWaitTime: data.sampleWaitTime
          });
          Object.assign(this.oldData, this.data);
        })
        .finally(this.clearLoading);
    },
    save() {
      this.confirmLoading = true;
      paramSetting({
        sn: this.sn,
        deviceType: this.deviceType,
        requestData: this.data
      })
        .then(res => {
          this.$message.success(res.message);
          this.handleClose();
        })
        .finally(this.clearLoading);
    }
  },
  created() {
    this.getDeviceStatus();
  }
};
</script>

<style lang="scss">
.bc500-setting {
  .el-dialog {
    min-width: 900px;
  }
  .el-form {
    display: flex;
  }
  .column {
    flex: 1;
  }
  .el-form-item {
    display: flex;
    .el-form-item__content {
      flex: 1;
      display: flex;
      .el-input {
        width: 230px;
      }
      .unit {
        margin-left: 20px;
      }
    }
  }
  .handler {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    .confirm {
      margin-right: 20px;
    }
  }
}
</style>
